import React from 'react'

const LinkOutlined = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.72534 7.7236C8.75323 6.6957 8.83119 4.70631 7.66553 3.54065L6.95854 2.83366C5.7871 1.66222 3.91403 1.63541 2.77559 2.77385C1.79471 3.75472 1.67922 5.2809 2.41549 6.43378C2.53624 6.6227 2.67717 6.79794 2.83581 6.95639"
        stroke="#0075FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.07539 6.07366C5.04791 7.10114 4.96995 9.09053 6.13561 10.2562L6.8426 10.9632C8.01404 12.1346 9.8867 12.1618 11.0251 11.0234C12.0064 10.0421 12.1223 8.51553 11.3856 7.36306C11.2649 7.17415 11.124 6.99891 10.9653 6.84045"
        stroke="#0075FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default LinkOutlined
